import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import DocumentLoader from 'routes/Documents/containers/DocumentLoaderContainer';
import DocumentProvider from 'routes/Documents/containers/DocumentProvider';
import { actions } from 'store/newDocumentStore';

import Rehabilitation from '../components/Rehabilitation';

const RehabilitationContainer = ({ edit, create }) => (
  <DocumentLoader names={['rehabilitation']}>
    <DocumentProvider>
      <Rehabilitation onStartEdit={edit} onCreate={create} />
    </DocumentProvider>
  </DocumentLoader>
);

RehabilitationContainer.propTypes = {
  edit: PropTypes.func,
  create: PropTypes.func,
};

export default connect(null, { edit: actions.createCommit, create: actions.createDocumentAndCommit })(
  RehabilitationContainer,
);
